var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLoader = function SvgIconLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.5 4.5 0 10 0s10 4.5 10 10h-4c0-3.3-2.7-6-6-6s-6 2.7-6 6 2.7 6 6 6v4C4.5 20 0 15.5 0 10z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
};
export { SvgIconLoader as ReactComponent };
export default "data:image/svg+xml,export default 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+CiAgICA8cGF0aCBkPSJNMCAxMEMwIDQuNSA0LjUgMCAxMCAwczEwIDQuNSAxMCAxMGgtNGMwLTMuMy0yLjctNi02LTZzLTYgMi43LTYgNiAyLjcgNiA2IDZ2NEM0LjUgMjAgMCAxNS41IDAgMTB6IgogICAgICAgICAgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg=='";